import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function FilterByPendigStatus({ getResultsByStatus }) {
  const [val, setVal] = React.useState(0);

  const handleChange = (event) => {
    setVal(event.target.value);
    
    getResultsByStatus(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 300 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Filter by status</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={val}
          label="Filter by status"
          onChange={handleChange}
        >
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={1}>Open Pending</MenuItem>
          <MenuItem value={2}>Open Declared</MenuItem>
          <MenuItem value={3}>Close Pending</MenuItem>
          <MenuItem value={4}>Close Declared</MenuItem>
          <MenuItem value={5}>Refund</MenuItem>
          <MenuItem value={6}>Both Pending</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
